import React, { useState, useRef, useEffect, useCallback } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { SketchPicker } from "react-color";
import "./QRCodeGenerator.css";
import Header from "./Header";
import Footer from "./Footer";
import html2canvas from "html2canvas";
import instagramLogo from "../src/assets/image/instagram.png";
import facebookLogo from "../src/assets/image/facebook.png";
import googleReviewLogo from "../src/assets/image/google-review.png";
import twitterLogo from "../src/assets/image/twitter.png";
import linkedinLogo from "../src/assets/image/linkdin.png";
import youtubeLogo from "../src/assets/image/youtube.png";
import whatsappLogo from "../src/assets/image/Whatsapp.png";
import pinterestLogo from "../src/assets/image/Pinterest.png";
import portfolioLogo from "../src/assets/image/web-portfolio.png";
import defaultLogo9r from "../src/assets/image/9r logo.png";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import firebaseApp from "./Firecontact";
import PropTypes from "prop-types";
import JsBarcode from "jsbarcode";
import QRCodeStyling from "qr-code-styling";
import { Link } from "react-router-dom";

// Enhanced ColorPicker subcomponent with click-outside functionality
const ColorPicker = ({
  label,
  color,
  onChange,
  show,
  toggle,
  presetColors,
}) => {
  const pickerRef = useRef();
  const popupRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        show &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        !pickerRef.current.contains(event.target)
      ) {
        toggle();
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, toggle]);

  return (
    <Form.Group className="color-picker-group">
      <Form.Label className="color-picker-label">{label}</Form.Label>
      <div className="color-picker-wrapper" ref={pickerRef}>
        <button
          type="button"
          className={`color-preview ${show ? "active" : ""}`}
          style={{ backgroundColor: color }}
          onClick={toggle}
        >
          <span className="color-preview-text">{color}</span>
        </button>
        {show && (
          <div className="color-picker-popup" ref={popupRef}>
            <div className="color-picker-header">
              <span className="color-picker-title">Choose Color</span>
              <button
                type="button"
                className="color-picker-close"
                onClick={toggle}
              >
                ×
              </button>
            </div>
            <SketchPicker
              color={color}
              onChange={(color) => {
                console.log("SketchPicker onChange:", color);
                onChange(color);
              }}
              onChangeComplete={(color) => {
                console.log("SketchPicker onChangeComplete:", color);
                onChange(color);
              }}
              presetColors={presetColors}
              className="sketch-picker-custom"
            />
            <div className="color-hex-input">
              <span className="hex-label">HEX:</span>
              <input
                type="text"
                value={color}
                onChange={(e) => onChange({ hex: e.target.value })}
                className="hex-input"
                placeholder="#000000"
              />
            </div>
          </div>
        )}
      </div>
    </Form.Group>
  );
};

ColorPicker.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  presetColors: PropTypes.array.isRequired,
};

// ToastNotification subcomponent
const ToastNotification = ({ show, message, onClose, isError }) =>
  show ? (
    <div className={`toast-notification${isError ? " error" : ""}`}>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  ) : null;

ToastNotification.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  isError: PropTypes.bool,
};

// Utility functions
const validateUrl = (url) => /^https?:\/\/.+\..+/.test(url);
const validatePhone = (phone) => /^\d{10,15}$/.test(phone.replace(/\D/g, ""));
const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const formatVCard = (name, phone, email, company, title, website) => {
  let vcard = `BEGIN:VCARD\nVERSION:3.0\nFN:${name}`;
  if (phone) vcard += `\nTEL:${phone}`;
  if (email) vcard += `\nEMAIL:${email}`;
  if (company) vcard += `\nORG:${company}`;
  if (title) vcard += `\nTITLE:${title}`;
  if (website) vcard += `\nURL:${website}`;
  vcard += `\nEND:VCARD`;
  return vcard;
};
const formatWiFi = (ssid, password) => `WIFI:T:WPA;S:${ssid};P:${password};;`;

const qrDotShapes = [
  { value: "square", label: "Square", icon: "icon-code-small-circles" },
  { value: "rounded", label: "Rounded", icon: "icon-code-large-rounded2" },
  { value: "dots", label: "Dots", icon: "icon-code-small-dots" },
];

const QRCodeGenerator = () => {
  const [text, setText] = useState("https://9rnfc.com/");
  const [qrColor, setQrColor] = useState("#000000");
  const [bgColor, setBgColor] = useState("#ffffff");
  const [customImg, setCustomImg] = useState("");
  const [noImg, setNoImg] = useState(false);
  const [showQrColorPicker, setShowQrColorPicker] = useState(false);
  const [showBgColorPicker, setShowBgColorPicker] = useState(false);
  const [, setDownloaded] = useState({ qr: false, theme: false });
  const [, setErrorCorrectionLevel] = useState("L");
  const [, setPreviewSize] = useState(200);
  const [theme, setTheme] = useState("default");
  const [themeLogo, setThemeLogo] = useState("");
  const [qrLogoImg, setQrLogoImg] = useState("");
  const [logoAspectRatio, setLogoAspectRatio] = useState(1);
  const [noThemeLogo, setNoThemeLogo] = useState(false);
  const [prevThemeLogo, setPrevThemeLogo] = useState("");
  const [transparentBg, setTransparentBg] = useState(false);
  const [yourName, setYourName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [website, setWebsite] = useState("");
  const [isDownloading, setIsDownloading] = useState({
    qr: false,
    theme: false,
  });
  const [, setQrComplexity] = useState("low");
  const [, setShowShortenUrl] = useState(false);
  const [qrType, setQrType] = useState("url");
  const [ssid, setSsid] = useState("");
  const [wifiPassword, setWifiPassword] = useState("");
  const [, setError] = useState("");
  const [toast, setToast] = useState({ show: false, message: "" });
  const [selectedUrlTheme, setSelectedUrlTheme] = useState("default");
  const [qrDotShape, setQrDotShape] = useState("square");
  const barcodeRef = useRef();
  const qrStylingRef = useRef();
  const [urlName, setUrlName] = useState("");
  const [urlMobile, setUrlMobile] = useState("");
  const [qrReady, setQrReady] = useState(false);

  const checkQRComplexity = (text) => {
    const length = text.length;
    if (length > 100) return "high";
    if (length > 50) return "medium";
    return "low";
  };

  // eslint-disable-next-line no-unused-vars

  useEffect(() => {
    setQrComplexity(checkQRComplexity(text));
  }, [text]);

  // Initialize QR ready state
  useEffect(() => {
    if (qrType === "text") {
      setQrReady(true);
    }
  }, [qrType]);

  // Monitor changes that require QR regeneration
  useEffect(() => {
    if (qrType !== "text" && qrStylingRef.current) {
      console.log("QR appearance changed - forcing regeneration");
      const qrElement = qrStylingRef.current;
      if (qrElement) {
        qrElement.innerHTML = "";
      }
    }
  }, [qrColor, bgColor, transparentBg, qrType, logoAspectRatio]);

  const saveQRDataToFirestore = async (qrType, qrData) => {
    try {
      const db = getFirestore(firebaseApp);
      let collectionName = "";

      // Use the data passed from the calling function, but ensure required fields are present
      let dataToSave = {
        ...qrData,
        createdAt: new Date().toISOString(),
      };

      // Determine collection name and add any missing type-specific data
      switch (qrType) {
        case "url":
          collectionName = "QRCodesURL";
          dataToSave = {
            ...dataToSave,
            url: text,
            name: urlName,
            mobile: urlMobile,
            type: "url",
          };
          break;

        case "text":
          collectionName = "QRCodesText-Barcode";
          dataToSave = {
            ...dataToSave,
            text: text,
            type: "text",
          };
          break;

        case "vcard":
          collectionName = "QRCodesVCard";
          dataToSave = {
            ...dataToSave,
            name: yourName,
            mobile: mobileNumber,
            email: email,
            company: company,
            jobTitle: jobTitle,
            website: website,
            type: "vcard",
            vcardData: formatVCard(
              yourName,
              mobileNumber,
              email,
              company,
              jobTitle,
              website
            ),
          };
          break;

        case "wifi":
          collectionName = "QRCodesWiFi";
          dataToSave = {
            ...dataToSave,
            ssid: ssid,
            password: wifiPassword,
            type: "wifi",
            wifiData: formatWiFi(ssid, wifiPassword),
          };
          break;

        default:
          collectionName = "QRCodesOther";
          dataToSave = {
            ...dataToSave,
            data: text,
            type: "other",
          };
      }

      const qrCollection = collection(db, collectionName);
      const docRef = await addDoc(qrCollection, dataToSave);

      const downloadType = qrData.downloadType || "unknown";
      setToast({
        show: true,
        message: `${qrType.toUpperCase()} QR Code (${downloadType}) saved successfully!`,
      });

      return docRef.id; // Return the document ID for reference
    } catch (error) {
      console.error("Error saving QR data: ", error);
      setToast({
        show: true,
        message: `Failed to save QR Code: ${error.message}`,
        isError: true,
      });
      throw error; // Re-throw to handle in the calling function if needed
    }
  };

  const handleThemeLogoUpload = (e) => {
    const file = e.target.files[0];
    if (!file || noThemeLogo) return;

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setThemeLogo(reader.result);
      }
    };
    reader.readAsDataURL(file);
  };

  const previewRef = useRef();

  const themeStyles = {
    default: {
      background: "#ffffff",
      border: "1px solid #ddd",
      boxShadow: "none",
      textColor: "#000000",
    },
    instagram: {
      background:
        "linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
      border: "none",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
      textColor: "#ffffff",
    },
    facebook: {
      background: "#3b5998",
      border: "none",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
      textColor: "#ffffff",
    },
    googlereview: {
      background: "#1A1A1A",
      border: "none",
      boxShadow: "0 6px 16px rgba(66, 133, 244, 0.4)",
      textColor: "#ffffff",
    },
    twitter: {
      background: "#15202B",
      border: "none",
      boxShadow: "0 4px 12px rgba(29,161,242,0.3)",
      textColor: "#ffffff",
    },
    linkedin: {
      background: "#0077b5",
      border: "none",
      boxShadow: "0 4px 12px rgba(0,119,181,0.3)",
      textColor: "#ffffff",
    },
    youtube: {
      background: "#FF0000",
      border: "none",
      boxShadow: "0 4px 12px rgba(255,0,0,0.3)",
      textColor: "#ffffff",
    },
    whatsapp: {
      background: "#25D366",
      border: "none",
      boxShadow: "0 4px 12px rgba(37, 211, 102, 0.3)",
      textColor: "#ffffff",
    },
    pinterest: {
      background: "#E60023",
      border: "none",
      boxShadow: "0 4px 12px rgba(230, 0, 35, 0.3)",
      textColor: "#ffffff",
    },
    portfolio: {
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      border: "none",
      boxShadow: "0 8px 32px rgba(0, 195, 255, 0.2)",
      textColor: "#232526",
    },
  };

  useEffect(() => {
    if (!noThemeLogo) {
      const logos = {
        instagram: instagramLogo,
        facebook: facebookLogo,
        googlereview: googleReviewLogo,
        twitter: twitterLogo,
        linkedin: linkedinLogo,
        youtube: youtubeLogo,
        whatsapp: whatsappLogo,
        pinterest: pinterestLogo,
        portfolio: portfolioLogo,
      };
      setCustomImg(logos[theme] || "");
    }
  }, [theme, noThemeLogo]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const ratio = img.width / img.height;
        setLogoAspectRatio(ratio);
        setQrLogoImg(event.target.result);
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  const getImageSettings = useCallback(() => {
    if (!qrLogoImg || noImg) return undefined;
    // Use a slightly larger logo for vCard for better visual balance
    const baseSize = qrType === "vcard" ? 70 : 50;
    let width, height;
    if (logoAspectRatio >= 1) {
      width = baseSize;
      height = width / logoAspectRatio;
    } else {
      height = baseSize;
      width = height * logoAspectRatio;
    }
    return {
      src: qrLogoImg,
      height: Math.round(height),
      width: Math.round(width),
      excavate: true,
    };
  }, [qrLogoImg, noImg, logoAspectRatio, qrType]);

  const getQrValue = useCallback(() => {
    if (qrType === "url") return text;
    if (qrType === "text") return text;
    if (qrType === "vcard")
      return formatVCard(
        yourName,
        mobileNumber,
        email,
        company,
        jobTitle,
        website
      );
    if (qrType === "wifi") return formatWiFi(ssid, wifiPassword);
    return text;
  }, [
    qrType,
    text,
    yourName,
    mobileNumber,
    email,
    company,
    jobTitle,
    website,
    ssid,
    wifiPassword,
  ]);

  const handleDownloadSuccess = (msg) => {
    setToast({ show: true, message: msg });
    setTimeout(() => setToast({ show: false, message: "" }), 4000);
  };

  const downloadQRCode = async (e) => {
    e.preventDefault();
    setIsDownloading({ ...isDownloading, qr: true });
    setError("");

    // Validation
    if (qrType === "url" && !validateUrl(text)) {
      setError("Please enter a valid URL starting with http:// or https://");
      setToast({
        show: true,
        message: "Please enter a valid URL starting with http:// or https://",
      });
      setIsDownloading({ ...isDownloading, qr: false });
      return;
    }
    if (qrType === "vcard" && (!yourName || !validatePhone(mobileNumber))) {
      setError("Please enter a valid name and phone number for vCard.");
      setToast({
        show: true,
        message: "Please enter a valid name and phone number for vCard.",
        isError: true,
      });
      setIsDownloading({ ...isDownloading, qr: false });
      return;
    }
    if (qrType === "vcard" && email && !validateEmail(email)) {
      setError("Please enter a valid email address.");
      setToast({
        show: true,
        message: "Please enter a valid email address.",
        isError: true,
      });
      setIsDownloading({ ...isDownloading, qr: false });
      return;
    }
    if (qrType === "wifi" && !ssid) {
      setError("Please enter a WiFi SSID.");
      setToast({
        show: true,
        message: "Please enter a WiFi SSID.",
        isError: true,
      });
      setIsDownloading({ ...isDownloading, qr: false });
      return;
    }

    try {
      // Save QR data to database before download
      console.log("Saving QR data to database for download type: qr_only");
      await saveQRDataToFirestore(qrType, {
        name: yourName,
        mobileNumber: mobileNumber,
        email: email,
        company: company,
        jobTitle: jobTitle,
        website: website,
        url: text.trim(),
        qrColor: qrColor,
        bgColor: bgColor,
        theme: theme,
        logoUsed: !noImg,
        qrLogoImg: qrLogoImg,
        themeLogo: themeLogo,
        downloadDate: new Date().toISOString(),
        downloadType: "qr_only",
        qrDotShape: qrDotShape,
        transparentBg: transparentBg,
        urlName: urlName,
        urlMobile: urlMobile,
        ssid: ssid,
        wifiPassword: wifiPassword,
      });

      if (qrType === "text") {
        if (!barcodeRef.current) {
          setError("Barcode element not found. Please try again.");
          return;
        }

        // Convert SVG to canvas for better compatibility
        const svgData = new XMLSerializer().serializeToString(
          barcodeRef.current
        );
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        canvas.width = 300 * 10;
        canvas.height = 100 * 10;

        // Set background
        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        img.onload = () => {
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          const dataUrl = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          const fileName = text.replace(/[^\w\d_-]/g, "_");
          link.href = dataUrl;
          link.download = `${fileName}_barcode.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          handleDownloadSuccess("Barcode downloaded and saved to database!");
          setIsDownloading({ ...isDownloading, qr: false });
        };

        img.src =
          "data:image/svg+xml;base64," +
          btoa(unescape(encodeURIComponent(svgData)));
      } else {
        // Create a new QR code instance with the same settings for download
        const qrData = getQrValue();
        const imageSettings = getImageSettings();

        // Create a temporary container for the download QR code
        const tempContainer = document.createElement("div");
        tempContainer.style.width = "1000px";
        tempContainer.style.height = "1000px";
        tempContainer.style.display = "flex";
        tempContainer.style.justifyContent = "center";
        tempContainer.style.alignItems = "center";
        tempContainer.style.backgroundColor = "#ffffff";
        // For vCard QR, reduce padding for compactness
        tempContainer.style.padding = qrType === "vcard" ? "10px" : "40px";

        // Create a container for the QR code with theme-specific styling
        const qrContainer = document.createElement("div");
        qrContainer.style.width = "1000px";
        qrContainer.style.height = "1000px";
        qrContainer.style.display = "flex";
        qrContainer.style.justifyContent = "center";
        qrContainer.style.alignItems = "center";
        qrContainer.style.backgroundColor = transparentBg
          ? "transparent"
          : bgColor;
        qrContainer.style.borderRadius =
          !transparentBg && theme !== "default" && theme !== "re"
            ? "12px"
            : "0";
        // For vCard QR, reduce padding for compactness
        qrContainer.style.padding = qrType === "vcard" ? "10px" : "40px";

        tempContainer.appendChild(qrContainer);
        document.body.appendChild(tempContainer);

        try {
          // Create a new QR code instance with high resolution
          const qrCode = new QRCodeStyling({
            width: 1000,
            height: 1000,
            data: qrData,
            dotsOptions: {
              color: qrColor,
              type: qrDotShape,
            },
            backgroundOptions: {
              color: transparentBg ? "transparent" : bgColor,
            },
            ...(qrType === "vcard"
              ? {
                qrOptions: { errorCorrectionLevel: "H" },
              }
              : {}),
            ...(imageSettings
              ? {
                image: imageSettings.src,
                imageOptions: {
                  width: imageSettings.width * 5,
                  height: imageSettings.height * 5,
                  crossOrigin: "anonymous",
                  margin: 0,
                  excavate: true,
                },
              }
              : {}),
          });

          // Clear the container and append the new QR code
          qrContainer.innerHTML = "";
          qrCode.append(qrContainer);

          // Give it a moment to render
          await new Promise((resolve) => setTimeout(resolve, 300));

          // Use html2canvas to capture the QR code
          const canvas = await html2canvas(qrContainer, {
            backgroundColor: transparentBg ? null : bgColor,
            scale: 1,
            useCORS: true,
            allowTaint: true,
            logging: false,
          });

          // Generate appropriate filename based on QR type
          let fileName;
          if (qrType === "vcard") {
            fileName = yourName ? yourName.replace(/[^\w\d_-]/g, "_") : "vcard";
          } else if (qrType === "wifi") {
            fileName = ssid ? ssid.replace(/[^\w\d_-]/g, "_") : "wifi";
          } else {
            fileName = text
              .replace(/^https?:\/\//, "")
              .replace(/[^\w\d_-]/g, "_");
          }

          // Create and trigger download
          const dataUrl = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = `${fileName}_qr_code.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          handleDownloadSuccess("QR code downloaded and saved to database!");
        } catch (error) {
          console.error("Error generating QR code for download:", error);
          setError("Error generating QR code image. Please try again.");
        } finally {
          // Clean up
          if (tempContainer.parentNode) {
            document.body.removeChild(tempContainer);
          }
        }
      }
    } catch (error) {
      console.error("Download error:", error);
      setError("Error downloading. Please try again.");
    } finally {
      setIsDownloading({ ...isDownloading, qr: false });
    }
  };

  const downloadThemeCard = async () => {
    setIsDownloading({ ...isDownloading, theme: true });

    try {
      if (!previewRef.current) return;

      console.log("Saving QR data to database for download type: theme_card");
      await saveQRDataToFirestore(qrType, {
        name: yourName,
        mobileNumber: mobileNumber,
        email: email,
        company: company,
        jobTitle: jobTitle,
        website: website,
        url: text.trim(),
        qrColor: qrColor,
        bgColor: bgColor,
        theme: theme,
        logoUsed: !noImg,
        qrLogoImg: qrLogoImg,
        themeLogo: themeLogo,
        downloadDate: new Date().toISOString(),
        downloadType: "theme_card",
        qrDotShape: qrDotShape,
        transparentBg: transparentBg,
        urlName: urlName,
        urlMobile: urlMobile,
        ssid: ssid,
        wifiPassword: wifiPassword,
      });

      await html2canvas(previewRef.current, {
        useCORS: true,
        backgroundColor: null,
        scale: 12,
      }).then((canvas) => {
        const dataUrl = canvas.toDataURL("image/png");
        const link = document.createElement("a");

        // Generate appropriate filename based on QR type
        let fileName;
        if (qrType === "vcard") {
          fileName = yourName ? yourName.replace(/[^\w\d_-]/g, "_") : "vcard";
        } else if (qrType === "wifi") {
          fileName = ssid ? ssid.replace(/[^\w\d_-]/g, "_") : "wifi";
        } else {
          fileName = text
            .replace(/^https?:\/\//, "")
            .replace(/[^\w\d_-]/g, "_");
        }

        link.href = dataUrl;
        link.download = `${fileName}_theme_card.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setDownloaded({ qr: false, theme: true });
        setTimeout(() => setDownloaded(false), 12000);
        handleDownloadSuccess("Theme card downloaded and saved to database!");
      });
    } catch (error) {
      console.error("Error downloading theme card:", error);
    } finally {
      setIsDownloading({ ...isDownloading, theme: false });
    }
  };

  const resetForm = () => {
    setText(qrType === "url" ? "https://9rnfc.com/" : "");
    setQrColor("#000000");
    setBgColor("#ffffff");
    setCustomImg("");
    setQrLogoImg("");
    setThemeLogo("");
    setPrevThemeLogo("");
    setNoImg(false);
    setNoThemeLogo(false);
    setErrorCorrectionLevel("L");
    setPreviewSize(200);
    setTheme("default");
    setSelectedUrlTheme("default");
    setYourName("");
    setMobileNumber("");
    setEmail("");
    setCompany("");
    setJobTitle("");
    setWebsite("");
    setShowShortenUrl(false);
    setSsid("");
    setWifiPassword("");
    setError("");
    setQrDotShape("square");
    setUrlName("");
    setUrlMobile("");
    setTransparentBg(false);
  };

  const handleQrColorChange = (color) => {
    console.log("QR Color changed to:", color.hex);
    setQrColor(color.hex);
    // No need to manually clear the element, the effect will handle it
  };
  const handleBgColorChange = (color) => {
    console.log("Background Color changed to:", color.hex);
    setBgColor(color.hex);
    // No need to manually clear the element, the effect will handle it
  };
  const toggleQrColorPicker = () => {
    setShowQrColorPicker(!showQrColorPicker);
    setShowBgColorPicker(false);
  };
  const toggleBgColorPicker = () => {
    setShowBgColorPicker(!showBgColorPicker);
    setShowQrColorPicker(false);
  };

  const handleQrTypeChange = (newType) => {
    setQrType(newType);
    // Reset all relevant fields including colors and preview details
    setQrColor("#000000");
    setBgColor("#ffffff");
    setYourName("");
    setMobileNumber("");
    setEmail("");
    setCompany("");
    setJobTitle("");
    setWebsite("");
    setSsid("");
    setWifiPassword("");
    setUrlName("");
    setUrlMobile("");
    setThemeLogo("");
    setQrLogoImg("");
    setNoImg(false);
    setNoThemeLogo(false);
    setPrevThemeLogo("");
    setQrDotShape("square");
    setTransparentBg(false);
    if (newType === "url") {
      setText("https://9rnfc.com/");
      setTheme("default");
      setSelectedUrlTheme("default");
    } else {
      setText("");
      setTheme("default");
      setSelectedUrlTheme("default");
    }
    // Force QR code regeneration by clearing the element
    if (qrStylingRef.current) {
      qrStylingRef.current.innerHTML = "";
    }
    setQrReady(false);
  };

  const handleUrlThemeChange = (newTheme) => {
    setSelectedUrlTheme(newTheme);
    setTheme(newTheme);
  };

  // Barcode rendering effect
  // Function to regenerate QR code
  const regenerateQRCode = useCallback(() => {
    if (qrType === "text" && barcodeRef.current) {
      try {
        console.log(
          `Regenerating barcode with QR Color: ${qrColor}, Background Color: ${bgColor}`
        );
        JsBarcode(barcodeRef.current, text || " ", {
          format: "CODE128",
          lineColor: qrColor,
          background: bgColor,
          width: 2,
          height: 80,
          displayValue: true,
          fontSize: 16,
          margin: 10,
          marginTop: 10,
          marginBottom: 10,
        });
        console.log("Barcode rendered successfully with colors");
      } catch (error) {
        console.error("Barcode generation error:", error);
        setError("Error generating barcode. Please check your input.");
      }
    } else if (qrStylingRef.current) {
      try {
        const imageSettings = getImageSettings();
        const qrData = getQrValue();

        console.log(
          `Regenerating QR with QR Color: ${qrColor}, Background: ${bgColor}, Transparent: ${transparentBg}`
        );

        const qrCode = new QRCodeStyling({
          width: 600,
          height: 600,
          data: qrData,
          dotsOptions: {
            color: qrColor,
            type: qrDotShape,
          },
          backgroundOptions: {
            color: transparentBg ? "transparent" : bgColor,
          },
          ...(qrType === "vcard"
            ? {
              qrOptions: { errorCorrectionLevel: "H" },
            }
            : {}),
          ...(imageSettings
            ? {
              image: imageSettings.src,
              imageOptions: {
                width: imageSettings.width,
                height: imageSettings.height,
                crossOrigin: "anonymous",
                margin: 0,
                excavate: true,
              },
            }
            : {}),
        });

        qrStylingRef.current.innerHTML = "";
        qrCode.append(qrStylingRef.current);
        setQrReady(true);
      } catch (error) {
        console.error("QR code regeneration error:", error);
        setError("Error regenerating QR code. Please try again.");
      }
    }
  }, [
    qrType,
    text,
    qrColor,
    bgColor,
    transparentBg,
    qrDotShape,
    getImageSettings,
    getQrValue,
  ]);

  // Effect to regenerate QR code when dependencies change
  useEffect(() => {
    regenerateQRCode();
  }, [regenerateQRCode]);

  // QR Styling rendering effect - now handled by regenerateQRCode
  useEffect(() => {
    // Removed unnecessary code here
  }, []);

  return (
    <>
      <Header />

      {/* SEO Meta Tags and Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "9R NFC QR Code Generator",
          "description": "Free online QR code generator with advanced customization options. Create QR codes for URLs, vCards, WiFi, and text with professional themes and logo integration.",
          "url": "https://9rnfc.com/QRCodeGenerator",
          "applicationCategory": "UtilityApplication",
          "operatingSystem": "Web Browser",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          },
          "featureList": [
            "URL QR Codes",
            "vCard QR Codes",
            "WiFi QR Codes",
            "Text/Barcode QR Codes",
            "Custom Colors",
            "Logo Integration",
            "Professional Themes",
            "High Quality Downloads"
          ],
          "provider": {
            "@type": "Organization",
            "name": "9R NFC",
            "url": "https://9rnfc.com",
            "email": "9rnfccard@gmail.com",
            "telephone": "+919925615191"
          }
        })}
      </script>

      <div className="qr-generator">
        <ToastNotification
          show={toast.show}
          message={toast.message}
          isError={toast.isError}
          onClose={() => setToast({ show: false, message: "" })}
        />
        <Container className="qr-container px-3">
          <Row className="justify-content-center align-items-start">
            <div className="my-3 text-center">
              <div className="d-flex justify-content-center">
                <h1 className="HeadingQRCode">9R NFC QR Code Generator</h1>
              </div>

              <div className="d-flex justify-content-center">
                <hr className="custom-line" />
              </div>
              <div className="mt-2 mb-3">
                <p className="lead qr-lead text-secondary text-center mx-auto">
                  Create professional QR codes instantly with our free online generator. Support for URLs, vCards, WiFi networks, and text with advanced customization options.
                </p>
              </div>
            </div>

            <Col
              xs={12}
              md={12}
              lg={8}
              className="qr-form-col p-md-2 p-0"
            >
              <Card className="form-card">
                <Card.Body className="bg-white p-0 p-md-3">
                  <h2 className="title">QR Code Generator</h2>
                  <p className="subtitle text-center">
                    Create professional QR codes with advanced customization
                    options
                  </p>
                  <Row className="align-items-center mb-3 justify-content-end">
                    <Col style={{ textAlign: "right" }}>
                      <Form.Group controlId="qrTypeSelector" className="mb-2">
                        <Form.Label
                          style={{
                            fontWeight: 700,
                            color: "var(--primary-color)",
                            fontSize: "1rem",
                            marginBottom: 6,
                            display: 'block'
                          }}
                        >
                          Choose QR Code Type
                        </Form.Label>
                        <Form.Select
                          value={qrType}
                          onChange={(e) => handleQrTypeChange(e.target.value)}
                          aria-label="Select QR Code Type"
                          className="mb-2"
                          style={{
                            fontSize: 15,
                            padding: "6px 40px 6px 12px",
                            minWidth: 120,
                            width: 'auto',
                            display: 'inline-block',
                            textAlign: 'left'
                          }}
                        >
                          <option value="url">URL</option>
                          <option value="text">Text / Barcode</option>
                          <option value="vcard">vCard (Contact)</option>
                          <option value="wifi">WiFi</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form className="qr-form" onSubmit={downloadQRCode}>
                    {qrType === "url" && (
                      <>
                        <Form.Group controlId="formText" className="mb-3">
                          <Form.Label>Enter URL</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="https://9rnfc.com/"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            className="input-text mb-2"
                          />
                          <Form.Text className="text-muted">
                            A default link is already filled in. You can change
                            it if you want.
                          </Form.Text>
                        </Form.Group>
                        <Row className="mb-0">
                          <Col md={6} xs={12} className="mb-2 mb-md-0">
                            <Form.Group controlId="urlName">
                              <Form.Label>Name (for theme card)</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter your name"
                                value={urlName}
                                onChange={(e) => setUrlName(e.target.value)}
                                className="input-text"
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6} xs={12}>
                            <Form.Group controlId="urlMobile">
                              <Form.Label>Mobile (for theme card)</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter your mobile number"
                                value={urlMobile}
                                onChange={(e) => setUrlMobile(e.target.value)}
                                className="input-text"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col md={6} xs={12} className="mb-2 mb-md-0">
                            <Form.Group controlId="urlThemeSelector">
                              <Form.Label>Select URL Theme</Form.Label>
                              <Form.Select
                                value={selectedUrlTheme}
                                className="py-2"
                                onChange={(e) =>
                                  handleUrlThemeChange(e.target.value)
                                }
                              >
                                <option value="default">Default</option>
                                <option value="instagram">Instagram</option>
                                <option value="facebook">Facebook</option>
                                <option value="googlereview">
                                  Google Review
                                </option>
                                <option value="twitter">Twitter</option>
                                <option value="linkedin">LinkedIn</option>
                                <option value="youtube">YouTube</option>
                                <option value="whatsapp">WhatsApp</option>
                                <option value="pinterest">Pinterest</option>
                                <option value="portfolio">
                                  Portfolio Website
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col md={6} xs={12}>
                            <Form.Group controlId="qrDotShapeSelector">
                              <Form.Label>QR Dot Shape</Form.Label>
                              <Form.Select
                                value={qrDotShape}
                                onChange={(e) => setQrDotShape(e.target.value)}
                                className="py-2"
                              >
                                {qrDotShapes.map((shape) => (
                                  <option key={shape.value} value={shape.value}>
                                    {shape.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}

                    {qrType === "text" && (
                      <Form.Group controlId="formTextPlain" className="mb-3">
                        <Form.Label>Enter Text or Barcode Data</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter any text or barcode information"
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          className="input-text mb-2"
                        />
                        <Form.Text className="text-muted">
                          Create QR codes for text, numbers, or barcode data.
                        </Form.Text>
                      </Form.Group>
                    )}

                    {qrType === "vcard" && (
                      <>
                        <Row>
                          <Col md={6}>
                            <Form.Group controlId="formName" className="mb-3">
                              <Form.Label>Full Name *</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter your full name"
                                value={yourName}
                                onChange={(e) => setYourName(e.target.value)}
                                className="input-text"
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group controlId="formMobile" className="mb-3">
                              <Form.Label>Mobile Number *</Form.Label>
                              <Form.Control
                                type="tel"
                                placeholder="Enter your mobile number"
                                value={mobileNumber}
                                onChange={(e) =>
                                  setMobileNumber(e.target.value)
                                }
                                className="input-text"
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={6}>
                            <Form.Group controlId="formEmail" className="mb-3">
                              <Form.Label>Email Address</Form.Label>
                              <Form.Control
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input-text"
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group
                              controlId="formCompany"
                              className="mb-3"
                            >
                              <Form.Label>Company</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter your company name"
                                value={company}
                                onChange={(e) => setCompany(e.target.value)}
                                className="input-text"
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={6}>
                            <Form.Group
                              controlId="formJobTitle"
                              className="mb-3"
                            >
                              <Form.Label>Job Title</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter your job title"
                                value={jobTitle}
                                onChange={(e) => setJobTitle(e.target.value)}
                                className="input-text"
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group
                              controlId="formWebsite"
                              className="mb-3"
                            >
                              <Form.Label>Website</Form.Label>
                              <Form.Control
                                type="url"
                                placeholder="Enter your website URL"
                                value={website}
                                onChange={(e) => setWebsite(e.target.value)}
                                className="input-text"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}

                    {qrType === "wifi" && (
                      <>
                        <Form.Group controlId="formSSID" className="mb-3">
                          <Form.Label>WiFi SSID</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter WiFi SSID"
                            value={ssid}
                            onChange={(e) => setSsid(e.target.value)}
                            className="input-text mb-2"
                          />
                        </Form.Group>
                        <Form.Group
                          controlId="formWifiPassword"
                          className="mb-3"
                        >
                          <Form.Label>WiFi Password</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter WiFi Password"
                            value={wifiPassword}
                            onChange={(e) => setWifiPassword(e.target.value)}
                            className="input-text mb-2"
                          />
                        </Form.Group>
                      </>
                    )}

                    <Row className="mb-4">
                      <Col md={6} xs={6}>
                        <ColorPicker
                          label="QR Color"
                          color={qrColor}
                          onChange={handleQrColorChange}
                          show={showQrColorPicker}
                          toggle={toggleQrColorPicker}
                          presetColors={[
                            "#000000",
                            "#FFFFFF",
                            "#FF0000",
                            "#00FF00",
                            "#0000FF",
                            "#FFFF00",
                            "#FF00FF",
                            "#00FFFF",
                          ]}
                        />
                      </Col>
                      <Col md={6} xs={6}>
                        <ColorPicker
                          label="Background"
                          color={bgColor}
                          onChange={handleBgColorChange}
                          show={showBgColorPicker}
                          toggle={toggleBgColorPicker}
                          presetColors={[
                            "#FFFFFF",
                            "#000000",
                            "#F0F0F0",
                            "#2C7DFA",
                            "#FF5733",
                            "#33FF57",
                            "#3357FF",
                            "#F3FF33",
                          ]}
                        />
                      </Col>
                    </Row>

                    <Form.Group
                      controlId="transparentBgCheckbox"
                      className="mb-3"
                    >
                      <Form.Check
                        type="checkbox"
                        label={
                          transparentBg
                            ? "Undo Transparent Background"
                            : "Remove QR Background"
                        }
                        checked={transparentBg}
                        onChange={(e) => {
                          console.log(
                            "Transparent background changed to:",
                            e.target.checked
                          );
                          setTransparentBg(e.target.checked);
                        }}
                        className="Hidelogo"
                      />
                    </Form.Group>

                    {qrType === "url" && (
                      <Row className="mb-2">
                        <Col md={6} xs={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>QR Code Logo</Form.Label>
                            <Form.Control
                              type="file"
                              accept="image/*"
                              onChange={handleImageUpload}
                              disabled={noImg}
                              className="file-input"
                            />
                          </Form.Group>
                          <Form.Group
                            controlId="HideLogoCheckbox"
                            className="mb-3"
                          >
                            <Form.Check
                              type="checkbox"
                              label="Hide logo"
                              checked={noImg}
                              onChange={(e) => setNoImg(e.target.checked)}
                              className="Hidelogo"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6} xs={12} className="mb-2 mb-md-0">
                          <Form.Group className="mb-3">
                            <Form.Label className="mb-2">
                              Theme Card Logo (not inside QR)
                            </Form.Label>
                            <Form.Control
                              type="file"
                              accept="image/*"
                              onChange={handleThemeLogoUpload}
                              disabled={noThemeLogo}
                              className="file-input"
                            />
                          </Form.Group>
                          <Form.Group controlId="noThemeLogoCheckbox">
                            <Form.Check
                              type="checkbox"
                              label="Hide logo"
                              checked={noThemeLogo}
                              className="Hidelogo"
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setNoThemeLogo(checked);
                                if (checked) {
                                  setPrevThemeLogo(themeLogo);
                                  setThemeLogo("");
                                } else {
                                  setThemeLogo(prevThemeLogo);
                                }
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    )}

                    {(qrType === "vcard" || qrType === "wifi") && (
                      <Row className="mb-2">
                        <Col xs={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>QR Code Logo</Form.Label>
                            <Form.Control
                              type="file"
                              accept="image/*"
                              onChange={handleImageUpload}
                              disabled={noImg}
                              className="file-input"
                            />
                          </Form.Group>
                          <Form.Group
                            controlId="HideLogoCheckbox"
                            className="mb-3"
                          >
                            <Form.Check
                              type="checkbox"
                              label="Hide logo"
                              checked={noImg}
                              onChange={(e) => setNoImg(e.target.checked)}
                              className="Hidelogo"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    )}

                    <div className="button-group d-grid gap-2 d-md-flex justify-content-md-between">
                      <Button
                        variant="outline-secondary"
                        onClick={resetForm}
                        className="reset-btn"
                      >
                        Reset All
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            <Col
              xs={12}
              sm={8}
              md={6}
              lg={4}
              className="preview-col p-md-2 p-0 sticky-preview"
            >
              <div className="d-flex justify-content-center flex-wrap text-center qr-code-preview mb-3">
                <h3 className="preview-title">QR Code Preview</h3>
              </div>
              <Card
                className="preview-card enhanced-preview rounded-0"
                style={{
                  ...themeStyles[theme],
                  borderRadius: "0px",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                  padding: "60px",
                  color: themeStyles[theme].textColor || "#000000",
                  position: "relative",
                  marginBottom: "20px",
                }}
                ref={previewRef}
              >
                <Card.Body className="d-flex flex-column align-items-center text-center rounded-0 bg-transparent p-0">
                  {theme !== "default" && (
                    <div
                      style={{
                        position: "absolute",
                        top: "20px",
                        right: "20px",
                        width: "40px",
                        height: "auto",
                      }}
                    >
                      <img
                        src={defaultLogo9r}
                        alt="9R Logo"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          opacity: ".8",
                        }}
                      />
                    </div>
                  )}
                  {customImg && (
                    <div className="theme-logo-top mb-3">
                      <img
                        src={customImg}
                        alt="Top Theme Logo"
                        style={{ maxWidth: "100px", height: "auto" }}
                      />
                    </div>
                  )}

                  {/* Show name/mobile for URL type */}
                  {qrType === "url" && (urlName || urlMobile) && (
                    <div className="contact-info mb-3 w-100 text-center">
                      {urlName && (
                        <div
                          className="fs-4 fw-600"
                          style={{ letterSpacing: "0.5px" }}
                        >
                          {urlName}
                        </div>
                      )}
                      {urlMobile && (
                        <div className="fs-5 fw-600">{urlMobile}</div>
                      )}
                    </div>
                  )}

                  {/* vCard preview */}
                  {qrType === "vcard" &&
                    (yourName || mobileNumber || email) && (
                      <div className="contact-info mb-2 w-100 text-center">
                        {yourName && (
                          <div
                            className="fs-5"
                            style={{ letterSpacing: "0.5px" }}
                          >
                            {yourName}
                          </div>
                        )}
                        {jobTitle && (
                          <div className="fs-6 text-muted">{jobTitle}</div>
                        )}
                        {company && (
                          <div className="fs-6 text-muted">{company}</div>
                        )}
                        {mobileNumber && (
                          <div className="fs-6">{mobileNumber}</div>
                        )}
                        {email && <div className="fs-6">{email}</div>}
                        {website && <div className="fs-6">{website}</div>}
                      </div>
                    )}

                  {/* Barcode or QR code preview */}
                  {qrType === "text" ? (
                    <div className="barcode-container">
                      <svg
                        ref={barcodeRef}
                        className="barcode-svg"
                        style={{
                          width: "100%", height: "auto"
                        }}
                      ></svg>
                    </div>
                  ) : (
                    <div className="qr-code-container">
                      <div
                        className={`qr-frame ${!transparentBg &&
                          theme !== "default" &&
                          theme !== "re"
                          ? "rounded"
                          : "rounded-0"
                          }`}
                        ref={qrStylingRef}
                        style={{
                          backgroundColor: transparentBg
                            ? "transparent"
                            : bgColor,
                          width: "200px",
                          height: "200px",
                          minHeight: "200px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: !transparentBg ? "15px" : "0px",
                        }}
                      />
                    </div>
                  )}

                  {themeLogo && (
                    <div className="theme-logo-preview mt-0">
                      <img
                        src={themeLogo}
                        alt="Theme Logo"
                        style={{ maxWidth: "100px", height: "auto" }}
                      />
                    </div>
                  )}
                </Card.Body>
              </Card>

              <div className="button-group d-flex justify-content-center flex-column mt-4">
                <Button
                  onClick={downloadQRCode}
                  disabled={isDownloading.qr || isDownloading.theme || !qrReady}
                  className="generate-btn mt-2 mb-0"
                  size="sm"
                  style={{ fontSize: 15, padding: "10px 18px" }}
                >
                  {isDownloading.qr ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Downloading...
                    </>
                  ) : !qrReady ? (
                    <>
                      <i className="lni lni-spinner me-2"></i>
                      Generating QR...
                    </>
                  ) : (
                    <>
                      <i className="lni lni-download me-2"></i>
                      Download QR Only
                    </>
                  )}
                </Button>

                <Button
                  onClick={downloadThemeCard}
                  disabled={isDownloading.qr || isDownloading.theme}
                  className="generate-btn"
                >
                  {isDownloading.theme ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Downloading...
                    </>
                  ) : (
                    <>
                      <i className="lni lni-download me-2"></i>
                      Download Full Theme Card
                    </>
                  )}
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="seo-container my-5 mt-md-5 mt-0">
          <section className="mb-4">
            <div className="my-3 text-center">
              <div className="d-flex justify-content-center">
                <h2 className="HeadingQRCode">9R NFC QR Code Generator</h2>
              </div>

              <div className="d-flex justify-content-center">
                <hr className="custom-line" />
              </div>
            </div>
            <p className="m-0">
              The 9R NFC QR Code Generator is a comprehensive tool designed to
              create smart, scannable QR codes with advanced customization
              options. Whether you're sharing a personal profile, digital
              business card, website, or contactless information, our tool
              ensures your QR codes are professional, customizable, and ready to
              impress.
            </p>
          </section>

          <section className="mb-4">
            <h3>Advanced Features</h3>
            <ul>
              <li>
                Create QR codes for URLs, text, vCards, WiFi networks, and more
              </li>
              <li>Supported QR dot shapes: Square, Rounded, Dots</li>
              <li>
                Professional themes for social media platforms and portfolio
                websites
              </li>
              <li>
                Enhanced vCard support with email, company, job title, and
                website
              </li>
              <li>High-quality downloads (PNG) with professional resolution</li>
              <li>Custom colors, backgrounds, and transparency options</li>
              <li>Logo integration and theme card customization</li>
            </ul>
          </section>

          <section className="mb-4">
            <h3>Professional Use Cases</h3>
            <p className="m-0">
              Perfect for <strong>business cards</strong>,{" "}
              <strong>digital networking</strong>, <strong>event badges</strong>
              , <strong>product labels</strong>,{" "}
              <strong>contactless menus</strong>, and promotional campaigns.
              Share your professional information via QR code for a modern,
              impressive introduction.
            </p>
          </section>

          <section className="mb-4">
            <h3>9R NFC QR Code Generator Services</h3>
            <div className="row">
              <div className="col-md-6">
                <h4>QR Code Types</h4>
                <ul>
                  <li>
                    <strong>URL QR Codes:</strong> Link to websites, social
                    media profiles, and online content
                  </li>
                  <li>
                    <strong>Text/Barcode QR Codes:</strong> Display text
                    messages, numbers, or barcode data
                  </li>
                  <li>
                    <strong>vCard QR Codes:</strong> Digital business cards with
                    contact information
                  </li>
                  <li>
                    <strong>WiFi QR Codes:</strong> Share WiFi network
                    credentials instantly
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <h4>Customization Features</h4>
                <ul>
                  <li>
                    <strong>Color Customization:</strong> Custom QR code and
                    background colors
                  </li>
                  <li>
                    <strong>Logo Integration:</strong> Add your logo to the
                    center of QR codes
                  </li>
                  <li>
                    <strong>Theme Cards:</strong> Professional themed cards with
                    QR codes
                  </li>
                  <li>
                    <strong>Dot Shapes:</strong> Square, rounded, or dot-style
                    QR patterns
                  </li>
                </ul>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <h4>Professional Themes</h4>
                <ul>
                  <li>
                    <strong>Social Media:</strong> Instagram, Facebook, Twitter,
                    LinkedIn themes
                  </li>
                  <li>
                    <strong>Business:</strong> Google Review, Portfolio,
                    Professional themes
                  </li>
                  <li>
                    <strong>Platforms:</strong> YouTube, WhatsApp, Pinterest
                    themes
                  </li>
                  <li>
                    <strong>Custom:</strong> Brand-specific theme customization
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <h4>Download Options</h4>
                <ul>
                  <li>
                    <strong>High Quality:</strong> PNG format with professional
                    resolution for print and digital use
                  </li>
                  <li>
                    <strong>QR Only:</strong> Clean QR code downloads
                  </li>
                  <li>
                    <strong>Theme Cards:</strong> Complete themed card designs
                  </li>
                  <li>
                    <strong>Transparent Background:</strong> Background-free QR
                    codes
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-4">
            <h3>Why Choose 9R NFC QR Code Generator?</h3>
            <div className="row">
              <div className="col-md-4">
                <h5>Free & Easy</h5>
                <p>100% free QR code generation with no sign-up required</p>
              </div>
              <div className="col-md-4">
                <h5>Professional Quality</h5>
                <p>High-resolution downloads suitable for business use</p>
              </div>
              <div className="col-md-4">
                <h5>Advanced Features</h5>
                <p>Multiple QR types, themes, and customization options</p>
              </div>
            </div>
          </section>

          <section className="mb-4 border-0">
            <h3>Perfect for Business & Personal Use</h3>
            <p className="m-0">
              Our QR Code Generator is designed for professionals, businesses,
              and individuals who need high-quality, customizable QR codes.
              Whether you're creating business cards, marketing materials,
              product labels, or personal contact sharing, our tool provides
              everything you need to create professional QR codes that match
              your brand and requirements.
            </p>
          </section>

          <section className="mb-4">
            <h3>Explore Our NFC Card Services</h3>
            <div className="row">
              <div className="col-md-6">
                <h4>Smart NFC Business Cards</h4>
                <p>
                  Take your networking to the next level with our advanced NFC business cards.
                  Simply tap your card on any smartphone to instantly share your contact information,
                  portfolio, or website. No app installation required - works with all modern smartphones.
                </p>
                <ul>
                  <li>Instant contact sharing with a single tap</li>
                  <li>Customizable design with your brand</li>
                  <li>Track analytics and engagement</li>
                  <li>Works with all NFC-enabled smartphones</li>
                </ul>
                <div className="mt-3">
                  <Link
                    to="/Products"
                    className="btn btn-primary"
                    style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '8px',
                      color: 'white',
                      textDecoration: 'none',
                      fontWeight: '600',
                      display: 'inline-block',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    📱 Buy NFC Cards
                  </Link>
                </div>
              </div>
              <div className="col-md-6 mt-md-0 mt-4">
                <h4>Complete Digital Solutions</h4>
                <p>
                  Beyond QR codes and NFC cards, we offer comprehensive digital solutions
                  to help your business grow. From website development to digital marketing,
                  we have everything you need to establish a strong online presence.
                </p>
                <ul>
                  <li>Website & Mobile App Development</li>
                  <li>Digital Marketing & SEO Services</li>
                  <li>UI/UX Design & Branding</li>
                  <li>E-commerce & Business Solutions</li>
                </ul>
                <div className="mt-3">
                  <Link
                    to="/Services"
                    className="btn btn-outline-primary"
                    style={{
                      border: '2px solid #667eea',
                      padding: '10px 20px',
                      borderRadius: '8px',
                      color: '#667eea',
                      textDecoration: 'none',
                      fontWeight: '600',
                      display: 'inline-block',
                      transition: 'all 0.3s ease',
                      background: 'transparent'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = '#667eea';
                      e.target.style.color = 'white';
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = 'transparent';
                      e.target.style.color = '#667eea';
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    ⚡ View All Services
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-4">
            <h3>Get Started Today</h3>
            <p className="m-0">
              Start creating professional QR codes instantly. No registration
              required, no hidden fees. Simply choose your QR code type,
              customize the design, and download your high-quality QR code ready
              for use.
            </p>
            <p className="m-0 mt-2">
              <strong>For business inquiries:</strong>{" "}
              <a
                href="https://9rnfc.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                9rnfc.com
              </a>{" "}
              |<strong> Email:</strong>{" "}
              <a href="mailto:9rnfccard@gmail.com">9rnfccard@gmail.com</a> |{" "}
              <strong> Phone:</strong>{" "}
              <a href="tel:+919925615191">+91 992 561 5191</a>
            </p>
          </section>

          <section className="d-none">
            <h4 className="text-muted">Target Keywords:</h4>
            <p className="text-muted">
              9R NFC QR Code Generator, Advanced QR Code Maker, Custom QR Code
              with Logo, QR Code for Business Cards, vCard QR Code Generator,
              WiFi QR Code Creator, Portfolio Website QR Code, High-Quality QR
              Code Online, QR Code Generator for Digital Cards, NFC Business
              Cards, Website Development, Mobile App Development, Digital
              Marketing, UI/UX Design, Smart Technology Solutions
            </p>
          </section>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default QRCodeGenerator;
